import React from "react";

import SkeletonWrapper from "./SkeletonWrapper";

const PickupReadinessSkeleton: React.FC = () => (
  <SkeletonWrapper width="100%" height="36">
    <rect x="0" y="0" rx="3" ry="3" width="100%" height="36" />
  </SkeletonWrapper>
);

export default PickupReadinessSkeleton;
